import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type CustomerConsent = Static<typeof CustomerConsentSchema>;
export const CustomerConsentSchema = Type.Object(
  {
    partyUid: Type.String(),
    timestamp: Type.String({ format: 'date-time' }),
    type: Type.String(),
    lotteryId: Type.String(),
    id: Type.String(),
  },
  { additionalProperties: false, $id: 'CustomerConsentSchema' }
);
